import { bool } from 'prop-types'

import ProductSpecialLabel from 'views/components/molecules/ProductSpecialLabel'

const ProductLabelOutOfTrade = ({ isOutOfTrade }) =>
  isOutOfTrade ? (
    <li className="u-vertical-align--top u-margin-small--bottom u-margin-small--right o-ProductLabels__ProductLabelContainer">
      <ProductSpecialLabel promotion="outOfTrade" />
    </li>
  ) : null

ProductLabelOutOfTrade.propTypes = {
  isOutOfTrade: bool.isRequired,
}

export default ProductLabelOutOfTrade
